/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkin_Qr_Show_CodeInputs */



/**
* | output |
* | --- |
* | "Show Check-in QR Code" |
*
* @param {Checkin_Qr_Show_CodeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const checkin_qr_show_code = /** @type {((inputs?: Checkin_Qr_Show_CodeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkin_Qr_Show_CodeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher le QR Code de pointage")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar código QR de check-in")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mostrar código QR de check-in")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra codice QR per il check-in")
	return /** @type {LocalizedString} */ ("Show Check-in QR Code")
});